import * as React from 'react';

export const WriteIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="pen"
      className="prefix__svg-inline--fa prefix__fa-pen prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="search"
      className="prefix__svg-inline--fa prefix__fa-search prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
      />
    </svg>
  );
};

// https://fontawesome.com/icons/user?style=solid
export const CharacterIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="user"
      className="prefix__svg-inline--fa prefix__fa-user prefix__fa-w-14"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
      />
    </svg>
  );
};

//https://fontawesome.com/icons/map-marker-alt?style=solid
export const SettingsIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="map-marker-alt"
      className="prefix__svg-inline--fa prefix__fa-map-marker-alt prefix__fa-w-12"
      viewBox="0 0 384 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
      />
    </svg>
  );
};

//https://fontawesome.com/icons/theater-masks?style=solid
export const EmotionsIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="theater-masks"
      className="prefix__svg-inline--fa prefix__fa-theater-masks prefix__fa-w-20"
      viewBox="0 0 640 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
      />
    </svg>
  );
};

//https://fontawesome.com/icons/cat?style=solid
export const AnimalIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cat"
      className="prefix__svg-inline--fa prefix__fa-cat prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
      />
    </svg>
  );
};

//https://fontawesome.com/icons/running?style=solid
export const ActionIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="running"
      className="prefix__svg-inline--fa prefix__fa-running prefix__fa-w-13"
      viewBox="0 0 416 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
      />
    </svg>
  );
};

// Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
export const PipeIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 450.833 450.833"
      data-icon="pipe"
      className="flaticon-pipe-icon"
      {...props}
    >
      <path
        fill="currentColor"
        d="M440.611 167.673a10 10 0 00-9.111-5.878H301.834a10 10 0 00-8.758 5.173c-1.172 2.127-10.865 21.506-12.11 82.009-13.242-7.715-28.566-28.692-44.595-50.634-11.311-15.484-23.384-32.006-36.851-47.177l-50.125 50.124c7.672 11.314 14.982 23.406 22.49 35.838 24.72 40.936 50.282 83.266 96.077 109.98 24.175 14.102 48.898 21.252 73.483 21.252 17.088 0 34.149-3.471 50.709-10.315 19.44-8.035 35.101-22.246 45.29-41.097 8.76-16.207 13.39-35.408 13.39-55.526-.001-69.158-9.177-91.436-10.223-93.749zM178.374 129.887c-7.354-6.488-15.117-12.368-23.368-17.354C127.58 95.957 75.316 82.472 38.5 82.472H24.667C11.065 82.472 0 93.537 0 107.138s11.065 24.667 24.667 24.667h15.062c34.618 2.774 61.009 14.332 83.034 36.357 2.873 2.873 5.64 5.887 8.337 8.999l47.274-47.274z"
      />
    </svg>
  );
};

// https://material.io/resources/icons/?search=tag&icon=local_offer&style=baseline
export const OtherIcon = (props) => {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
      />
    </svg>
  );
};

//Material UI 'category' icon
export const DescriptiveIcon = (props) => {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} {...props}>
      <path fill="currentColor" d="M12 2l-5.5 9h11z" />
      <circle fill="currentColor" cx={17.5} cy={17.5} r={4.5} />
      <path fill="currentColor" d="M3 13.5h8v8H3z" />
      <path fill="currentColor" d="M0 0h24v24H0z" />
    </svg>
  );
};

// Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
export const ThemeIcon = (props) => {
  return (
    <svg viewBox="0 0 295.6 295.6" {...props}>
      <path
        fill="currentColor"
        d="M135.253 53.605l44.85 24.044c1.559.835 3.543 1.295 5.586 1.295h.001c1.444 0 2.831-.238 4.011-.689l31.794-12.188c2.601-.997 4.246-3.064 4.401-5.529.156-2.465-1.217-4.722-3.672-6.037l-44.849-24.044c-1.559-.835-3.542-1.295-5.585-1.295-1.446 0-2.834.239-4.013.691L135.981 42.04c-2.601.997-4.245 3.064-4.4 5.529-.155 2.465 1.218 4.722 3.672 6.036zM208.367 25.579l44.85 24.042c1.559.835 3.543 1.295 5.587 1.295 1.446 0 2.833-.238 4.012-.69l.44-.168c1.992-.764 3.569-2.261 4.44-4.215s.93-4.128.166-6.119l-13.26-34.59C253.424 2.063 250.419 0 247.124 0c-.979 0-1.939.178-2.855.528l-35.173 13.484c-2.601.997-4.245 3.064-4.4 5.529-.156 2.466 1.217 4.723 3.671 6.038zM62.139 81.635l44.847 24.041c1.559.836 3.543 1.297 5.588 1.297 1.446 0 2.833-.239 4.012-.69l31.791-12.188c2.602-.996 4.248-3.062 4.404-5.526.157-2.465-1.215-4.724-3.672-6.042L104.26 58.484c-1.56-.835-3.544-1.295-5.587-1.295-1.447 0-2.834.238-4.011.689L62.869 70.067c-2.602.998-4.247 3.065-4.402 5.53-.156 2.466 1.218 4.723 3.672 6.038z"
      />
      <path
        fill="currentColor"
        d="M273.104 124.6h-.473c-3.113 0-6.71 1.255-8.744 3.609L232.104 164.6h-25.035l26.132-30.066c1.822-2.107 2.296-4.403 1.27-6.65-1.027-2.246-3.304-3.284-6.09-3.284H194.33c-3.112 0-6.708 1.254-8.745 3.609L153.801 164.6h-25.035l26.132-30.066c1.822-2.107 2.296-4.403 1.27-6.65-1.027-2.246-3.304-3.284-6.09-3.284h-34.051c-3.112 0-6.708 1.254-8.745 3.609L75.498 164.6H49.315l28.384-37.485c.618-.82 1.002-1.522 1.23-2.259a5.49 5.49 0 00.664-1.75c.464-2.466-.684-4.855-3.071-6.428l-45.124-29.71c-2.651-1.747-6.858-2.21-9.848-1.065l-1.736.668c-3.938 1.51-6.155 5.881-5.05 9.949l9.046 34.404c.149.549.31 1.069.31 1.561v147.086c0 9.101 8.007 16.029 17.107 16.029h223.372c9.101 0 16.521-6.929 16.521-16.029V132.168c0-4.411-3.605-7.568-8.016-7.568zm-70.387 131H70.908c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15h131.809c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
      />
    </svg>
  );
};

export const DreamtypeIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="moon"
      className="prefix__svg-inline--fa prefix__fa-moon prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 00283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
      />
    </svg>
  );
};

// FontAwesome 'palette' icon
export const PaletteIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
      />
    </svg>
  );
};

// Material UI 'create' icon
export const EditIcon = (props) => {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </svg>
  );
};

// FA 'times' icon
export const DeleteIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="times"
      className="prefix__svg-inline--fa prefix__fa-times prefix__fa-w-11"
      viewBox="0 0 352 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      />
    </svg>
  );
};

// Astronaut
export const AstronautIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fad"
      data-icon="user-astronaut"
      className="prefix__svg-inline--fa prefix__fa-user-astronaut prefix__fa-w-14"
      viewBox="0 0 448 512"
      {...props}
    >
      <g className="prefix__fa-group">
        <path
          className="prefix__fa-secondary"
          fill="currentColor"
          d="M296 96H152c-26.5 0-48 17.9-48 40v24a96 96 0 0096 96h48a96 96 0 0096-96v-24c0-22.1-21.5-40-48-40zm-108 76l-12 36-12-36-36-12 36-12 12-36 12 36 36 12zm-12 276a16 16 0 00-16 16v48h32v-48a16 16 0 00-16-16zm96 0a16 16 0 1016 16 16 16 0 00-16-16z"
          opacity={0.4}
        />
        <path
          className="prefix__fa-primary"
          fill="currentColor"
          d="M327.6 321.4a190.68 190.68 0 01-207.2 0C52.9 328.5 0 385 0 454.4v9.6a48 48 0 0048 48h80v-64a32 32 0 0132-32h128a32 32 0 0132 32v64h80a48 48 0 0048-48v-9.6c0-69.4-52.9-125.9-120.4-133zM64 224h13.5a159.78 159.78 0 00293 0H384a16 16 0 0016-16v-96a16 16 0 00-16-16h-13.5a159.78 159.78 0 00-293 0H64a16 16 0 00-16 16v96a16 16 0 0016 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24a96 96 0 01-96 96h-48a96 96 0 01-96-96z"
        />
      </g>
    </svg>
  );
};

export const SparklesIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="sparkles"
      className="prefix__svg-inline--fa prefix__fa-sparkles prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M324.42 103.15L384 128l24.84 59.58a8 8 0 0014.32 0L448 128l59.58-24.85a8 8 0 000-14.31L448 64 423.16 4.42a8 8 0 00-14.32 0L384 64l-59.58 24.84a8 8 0 000 14.31zm183.16 305.69L448 384l-24.84-59.58a8 8 0 00-14.32 0L384 384l-59.58 24.84a8 8 0 000 14.32L384 448l24.84 59.58a8 8 0 0014.32 0L448 448l59.58-24.84a8 8 0 000-14.32zM384 255.64a16.06 16.06 0 00-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 241.31a16 16 0 000 28.67l112.57 56.39 56.28 112.77a16 16 0 0028.62 0l56.28-112.77L375.16 270a16.07 16.07 0 008.84-14.36z"
      />
    </svg>
  );
};

export const BackArrow = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="arrow-left"
      className="prefix__svg-inline--fa prefix__fa-arrow-left prefix__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="check"
      className="prefix__svg-inline--fa prefix__fa-check prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      />
    </svg>
  );
};

// Bar chart
export const BarChartIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fad"
      data-icon="chart-bar"
      className="prefix__svg-inline--fa prefix__fa-chart-bar prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}
    >
      <g className="prefix__fa-group">
        <path
          className="prefix__fa-secondary"
          fill="currentColor"
          d="M512 400v32a16 16 0 01-16 16H32a32 32 0 01-32-32V80a16 16 0 0116-16h32a16 16 0 0116 16v304h432a16 16 0 0116 16z"
          opacity={0.4}
        />
        <path
          className="prefix__fa-primary"
          fill="currentColor"
          d="M275.2 96h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8zm-96 128h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8zm288-160h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8zm-96 96h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8z"
        />
      </g>
    </svg>
  );
};

export const TrashSolidIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="trash"
      className="prefix__svg-inline--fa prefix__fa-trash prefix__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M432 32H312l-9.4-18.7A24 24 0 00281.1 0H166.8a23.72 23.72 0 00-21.4 13.3L136 32H16A16 16 0 000 48v32a16 16 0 0016 16h416a16 16 0 0016-16V48a16 16 0 00-16-16zM53.2 467a48 48 0 0047.9 45h245.8a48 48 0 0047.9-45L416 128H32z"
      />
    </svg>
  );
};

export const TrashRegularIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="trash"
      className="prefix__svg-inline--fa prefix__fa-trash prefix__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M432 80h-82.4l-34-56.7A48 48 0 00274.4 0H173.6a48 48 0 00-41.2 23.3L98.4 80H16A16 16 0 000 96v16a16 16 0 0016 16h16l21.2 339a48 48 0 0047.9 45h245.8a48 48 0 0047.9-45L416 128h16a16 16 0 0016-16V96a16 16 0 00-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z"
      />
    </svg>
  );
};

export const categoryIcons = {
  CHARACTER: <CharacterIcon color="currentColor" height="15" width="15" />,
  SETTING: <SettingsIcon color="currentColor" height="15" width="15" />,
  EMOTION: <EmotionsIcon color="currentColor" height="15" width="15" />,
  ACTION: <ActionIcon color="currentColor" height="15" width="15" />,
  ANIMAL: <AnimalIcon color="currentColor" height="15" width="15" />,
  DESCRIPTIVE: <DescriptiveIcon color="currentColor" height="15" width="15" />,
  THEME: <ThemeIcon color="currentColor" height="15" width="15" />,
  DREAMTYPE: <DreamtypeIcon color="currentColor" height="15" width="15" />,
  COLOR: <PaletteIcon color="currentColor" height="15" width="15" />,
  OTHER: <OtherIcon color="currentColor" height="15" width="15" />,
};

export const renderCategoryIcon = (category) => {
  return categoryIcons[category];
};
